import { Renew16, Add16 } from "@carbon/icons-react"
import { changeOrderdQuizQuestionOptions, deleteQuizQuestionOptions, getQuizQuestionOptions } from "api/functions/functions"
import { InlineLoading, Modal, Tag } from "carbon-components-react"
import ModalQuizQuestionOption from "components/ModalQuizQuestionOption/ModalQuizQuestionOption"
import { useEffect, useState } from "react"
import Button from "ui/Button"
import ButtonSet from "ui/ButtonSet/ButtonSet"
import TileWrapper from "ui/TileWrapper/TileWrapper"

const QuizQuestionOptions = ({ questionId, ...props }) => {

    const [options, setOptions] = useState()
    const [loading, setLoading] = useState(false)
    const [selectedItem, setSelectedItem] = useState()
    const [modalIsOpen, setModalIsOpen] = useState(false)
    const [deleteModalIsOpen, setDeleteModalIsOpen] = useState(false)
    const [idToDelete, setIdToDelete] = useState()
    const [deleting, setDeleting] = useState(false)

    useEffect(() => {
        loadData()
    }, [])

    const loadData = async () => {
        setLoading(true)
        // load data setOptions
        const res = await getQuizQuestionOptions({
            questionId
        })
        setOptions(res?.data)
        setLoading(false)
    }

    const reload = () => {
        loadData()
    }

    const selectItem = (e) => {
        e = e || {}
        setSelectedItem(e)
        setModalIsOpen(true)
    }

    const closeModal = () => {
        setSelectedItem({})
        setModalIsOpen(false)
    }

    const onSubmit = () => {
        loadData()
    }

    const goUp = (position) => {
        move(position, position - 1)
    }
    const goDown = (position) => {
        move(position, position + 1)
    }

    const move = (position, newPosition) => {
        let newCollection = [...options]
        const removed = newCollection.splice(position, 1)
        newCollection.splice(newPosition, 0, removed[0])
        setOptions(newCollection)

        changeOrderdQuizQuestionOptions({
            questionId,
            order: newCollection.map(item => item.id)
        })
        // if (props.onSort) {
        //     props.onSort(newCollection.map(item => item.id))
        // }
    }

    const openDeleteModal = (id) => {
        setIdToDelete(id)
        setDeleteModalIsOpen(true)
    }

    const closeDeleteModal = () => {
        setIdToDelete()
        setDeleteModalIsOpen(false)
    }

    const deleteCategory = async () => {
        setDeleting(true)
        try {
            const res = await deleteQuizQuestionOptions(idToDelete)
            loadData()
        }
        catch (e) { }
        finally {
            setDeleting(false)
            closeDeleteModal()
        }
    }

    const getRows = () => {
        return options?.length ? options.map((item, index) => {
            return (
                <TileWrapper
                    selected={(
                        props.selectedItem?.id === item.id
                    )}
                    key={`main-list-item-${item?.id}-${index}`}
                    title={(
                        <small>
                            {item.body_default}{item.is_correct ? (
                                <Tag type="green">Correct</Tag>
                            ) : ""}
                        </small>
                    )}
                    onTitleClicked={() => selectItem(item)}
                    // footer={(
                    //     <a onClick={() => askForDeletingTab(item.id)}>
                    //         <Delete16 />
                    //     </a>
                    // )}
                    enableGoUp={index > 0}
                    enableGoDown={index < options.length - 1}
                    goUp={() => goUp(index)}
                    goDown={() => goDown(index)}
                >
                    <Button
                        kind="ghost"
                        size="small"
                        onClick={() => openDeleteModal(item.id)}
                    >
                        Delete
                    </Button>

                </TileWrapper>
            )
        }) : "Empty"
    }

    return (
        <>
            <ButtonSet>
                <Button
                    kind="primary"
                    size='field'
                    disabled={loading}
                    onClick={reload}
                    renderIcon={Renew16}
                    iconDescription="Refresh"
                    hasIconOnly
                />
                <Button
                    kind="secondary"
                    renderIcon={Add16}
                    hasIconOnly
                    size='field'
                    iconDescription="Create new"
                    className="btn-add-item btn-remove-item__top-center"
                    onClick={() => selectItem()}
                />
            </ButtonSet>
            {
                loading ? <InlineLoading /> : getRows()
            }
            <ModalQuizQuestionOption
                defaultValues={selectedItem}
                onClose={closeModal}
                open={modalIsOpen}
                questionId={questionId}
                onSubmit={onSubmit}
            />
            <Modal
                open={deleteModalIsOpen}
                danger={true}
                onRequestSubmit={() => deleteCategory()}
                onRequestClose={() => closeDeleteModal()}
                onSecondarySubmit={() => closeDeleteModal()}
                primaryButtonText="Continue"
                secondaryButtonText="Cancel"
                primaryButtonDisabled={deleting}
                size="xs"
                modalHeading="Delete option"
            >
                <div>
                    Selected option will be permanently deleted.
                </div>
                <div>
                    Are you sure you want to confirm?
                </div>
            </Modal>
        </>
    )
}
export default QuizQuestionOptions